module.exports = __webpack_public_path__ + "static/media/circle-loader.51b752cd.svg";